// extracted by mini-css-extract-plugin
module.exports = {"container":"FarePromoBadge_container__nTp1n","icon-url":"FarePromoBadge_icon-url__WDAHL","iconUrl":"FarePromoBadge_icon-url__WDAHL","icon":"FarePromoBadge_icon__TaiKa"};